var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51731 30.002H24.4827H24.4924C27.5357 29.9966 30 27.528 30 24.4846V7.50954C29.9946 4.46621 27.526 2.00195 24.4827 2.00195H7.50759C4.46426 2.00731 2 4.47593 2 7.51926V24.4944C2.00536 27.5377 4.47397 30.002 7.51731 30.002ZM12.4701 12.4744C12.7289 12.2155 13.08 12.0702 13.446 12.0704L18.5488 12.071C19.3105 12.071 19.9281 12.6885 19.9281 13.4502V18.5536C19.9281 18.9194 19.7827 19.2702 19.5241 19.5289C19.2654 19.7875 18.9146 19.9329 18.5488 19.9329H13.4454C12.6837 19.9329 12.0661 19.3154 12.0661 18.5536V13.4502C12.066 13.0842 12.2113 12.7332 12.4701 12.4744Z",
    fill: "url(#paint0_linear_2059_50894)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2059_50894",
    x1: 2,
    y1: 2.00195,
    x2: 2,
    y2: 30.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.4df281e523c1ad61be187a29c56d7834.svg";
export { ForwardRef as ReactComponent };